
import { prop, Options, Vue } from "vue-class-component";
import RadioButton from "primevue/radiobutton";
import { LOCATION_AREA } from "../misc";

class Props {
  data = prop<Array<any>>({
    type: Array,
    default: LOCATION_AREA,
  });
  modelValue = prop<boolean>({
    type: Boolean,
    default: false,
  });
}
@Options({
  emits: ["confirmArea", "update:modelValue"],
  components: {
    RadioButton,
  },
})
export default class ModalAreaScan extends Vue.with(Props) {
  dataArea = {
    locationArea: "",
    radioLocationArea: ""
  };

  onChangeRadioValue(data: any) {
    this.dataArea.radioLocationArea = data.value;

    if (this.dataArea.radioLocationArea !== 'OTHERS') {
      this.dataArea.locationArea = "";
    }
  }

  cancelArea() {
    this.$emit("update:modelValue", false);
    this.$emit("close");
  }

  confirmArea() {
    this.$emit("confirmArea", this.dataArea);
    this.cancelArea();
  }

  get disabledBtn() {
    return !this.dataArea.radioLocationArea || (this.dataArea.radioLocationArea === 'OTHERS' && !this.dataArea.locationArea)
  }
}
